export default [
    {
      name: 'Mapa',
      icon: 'nc-icon nc-pin-3',
      path: '/home'
    },
    {
      name: 'Reportes',
      icon: 'nc-icon nc-chart-bar-32',
      path: '/reports'
    }
    // {
    //   name: 'Zonas',
    //   icon: 'nc-icon nc-map-big',
    //   path: '/zones'
    // }
  //   {
  //     name: 'Tendencias',
  //     icon: 'nc-icon nc-sound-wave',
  //     path: '/trends'
  //   }
  ]